import { Dispatch } from 'redux';

import {
  FETCH_STATIC_CONTENT_INIT,
  FETCH_STATIC_CONTENT_ERROR,
  FETCH_STATIC_CONTENT_SUCCESS,
  StaticContentActionTypes,
} from './types';
import { StaticContent } from 'shared/types';
import { apiGetRequest } from 'utils/http/apiHttp';
import { staticContentStorage } from 'utils/staticContent/staticContentStorage';
import { getSystemSetting } from 'utils/systemSetting/systemSetting';

const fetchStaticContentInit = (): StaticContentActionTypes => {
  return {
    type: FETCH_STATIC_CONTENT_INIT,
  };
};

const fetchStaticContentSuccess = (
  data: StaticContent
): StaticContentActionTypes => {
  return {
    type: FETCH_STATIC_CONTENT_SUCCESS,
    data,
  };
};

const fetchStaticContentError = (error: string): StaticContentActionTypes => {
  return {
    type: FETCH_STATIC_CONTENT_ERROR,
    error,
  };
};

export const fetchStaticContent = () => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(fetchStaticContentInit());
      const respContent = await apiGetRequest(`pet/content`);
      const staticContent = respContent?.json?.content || null;
      const systemSetting = await getSystemSetting();
      const content = {
        ...staticContent,
        systemSetting,
      };

      dispatch(fetchStaticContentSuccess(content));
      staticContentStorage.setContent(content);
    } catch ({ message }) {
      dispatch(fetchStaticContentError(message));
    }
  };
};
